import React, { Component } from 'react'
import { connect } from 'react-redux'
import { parse } from 'query-string'
import loadable from '@loadable/component'
import * as actions from '../../actions/cart'
import * as actionsNotification from '../../actions/notification'
import * as actionsCookies from '../../actions/cookies'
import * as actionsActiveStore from '../../actions/activeStore'
import * as actionsCheckout from '../../actions/checkout'
import { bindActionCreators } from 'redux'
import { Col, Row } from 'reactstrap'
import cloneDeep from 'lodash/cloneDeep'
import { isMobile } from 'react-device-detect'
import localStorageService from '../../api/services/localStorageService'
import AboutHausmart from '../../components/shared/Store/AboutHausmart/AboutHausmart'
import { BlurredWrapper, Content } from '../../components/shared/Store/StoreStyledComponents'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { ThemeProvider } from 'styled-components/macro'
import { TopBarNotificationBox } from '../../components/shared/NotificationBox/TopBarNotificationBox'
import { MdLocationOff } from 'react-icons/md'
import CampaignBanner from '../../components/shared/CampaignBanner/CampaignBanner'
import isEmpty from 'lodash/isEmpty'
import { getProductsByFilledCart } from './helpers/getProductsByFilledCart'
import { listenOnChanges } from './helpers/listenOnChanges'
import { getMissingProductInFilledCart } from './helpers/getMissingProductsInFilledCart'
import StoreViewTopBar from './StoreViewTopBar.tsx'
import StoreViewHeader from './StoreViewHeader.tsx'
import StoreViewProducts from './StoreViewProducts.tsx'
import ProductDetailsModal from '../../components/shared/Store/ProductDetailsModal/ProductDetailsModal'
import { BackToThirdPartyBar } from 'components/shared/BackToThirdPartyBar/BackToThirdPartyBar'

const CheckoutModal = loadable(() => import('./Checkout/CheckoutModal'))
const CheckoutWidgetButton = loadable(() => import('./CheckoutWidgetButton/CheckoutWidgetButton'))
// const ChatWidget = loadable(() => import('./Chat/ChatWidget'))

class StoreView extends Component {
  state = {
    checkoutModalShow: false,
    modalProduct: null
  }

  componentDidMount() {
    const params = parse(this.props.location.search)
    this.imageId = params.image_id || null
    this.ct = params.ct || null
    this.mobile = isMobile
    if (this.props.activeStore._id) {
      this.initWebsockets()
    }
  }

  componentDidUpdate(prevProps) {
    if (this._storeChanged(prevProps.activeStore._id)) {
      this.mapLocationStateProductsToCart()
      this.initWebsockets()
    }
  }

  initWebsockets = () => {
    listenOnChanges(
      this.props.activeStore.getShortId(),
      this.onProductsStockChanged,
      this.correctCartWhenNotEnoughInStore,
      this.onStoreStockSettingChanged,
      this.onProductStockSettingChanged,
      this.onStoreShippingSettingChanged,
      this.onProductShippingSettingChanged
    )
  }

  mapLocationStateProductsToCart = () => {
    const { location, actions, actionsCheckout, activeStore } = this.props
    if (location.state && !isEmpty(location.state.filledCart) && activeStore) {
      const products = getProductsByFilledCart(location.state.filledCart, activeStore)
      if (products.length > 0) {
        actions.fillCart(products)
        const missingProducts = getMissingProductInFilledCart(location.state.filledCart, activeStore)
        actionsCheckout.setMissingProducts(missingProducts)
        this.toggleCheckoutModal()
      } else {
        // @todo add notification that no products available right now cause probably product was delated
      }
      // @todo Support case where no item from filled card are curently out of stock. Probably notification
      this.clearFilledCartState()
    }
  }

  clearFilledCartState() {
    this.props.history.replace({
      pathname: this.props.location.pathname,
      state: {
        filledCart: null
      }
    })
  }

  _storeChanged(prevStoreId) {
    return prevStoreId !== this.props.activeStore._id
  }

  _stockSettingChanged(isStockEnabled) {
    return isStockEnabled !== this.props.activeStore.isStockEnabled()
  }

  onStoreStockSettingChanged = event => {
    this.props.actionsActiveStore.setStockEnabled(event.status)
    if (event.status) {
      this.correctCartWhenNotEnoughInStore()
    }
  }

  onProductStockSettingChanged = event => {
    event.products.forEach(product => {
      this.props.actionsActiveStore.setProductStockEnabled(product._id, product.status)
      if (product.status) {
        this.correctCartWhenNotEnoughInStore()
      }
    })
  }

  onStoreShippingSettingChanged = event => {
    this.props.actionsActiveStore.setShippingEnabled(event.status)
  }

  onProductShippingSettingChanged = event => {
    event.products.forEach(product => {
      this.props.actionsActiveStore.setProductShippingEnabled(product._id, product.status)
    })
  }

  componentWillUnmount() {
    localStorageService.clearShippingDetails()
  }

  correctCartWhenNotEnoughInStore = () => {
    this.props.activeStore.getProducts().forEach(item => {
      this.props.cart.onProductStockInsufficient(item, true, this.onNoneAvailable, this.onFewAvailable)
    })
  }

  onNoneAvailable = (item, availableStock, requiredStock) => {
    if (!this.props.checkout.isPaypalPending) {
      const id = item._id
      const productName = this.props.activeStore.findProductById(id).getName()
      this.displayRemoveFromCartNotification(productName, availableStock, requiredStock)
      this.props.actions.clearProduct(id)
    }
  }

  onFewAvailable = (item, availableStock, requiredStock) => {
    if (!this.props.checkout.isPaypalPending) {
      const id = item._id
      const productName = this.props.activeStore.findProductById(id).getName()
      this.displayChangeCartStockNotification(productName, availableStock, requiredStock)
      this.props.actions.changeProductQuantity(id, availableStock)
    }
  }

  onProductsStockChanged = stock => {
    this.updateStoreStock(stock)
    stock.products.forEach(item => {
      this.props.cart.onProductStockInsufficient(item, false, this.onNoneAvailable, this.onFewAvailable)
    })
  }

  displayRemoveFromCartNotification = productName => {
    const { intl } = this.props
    this.props.actionsNotification.showNotification({
      title: intl.formatMessage({
        id: 'store.notifications.removedFromCart.title'
      }),
      type: 'warning',
      message: intl.formatMessage({ id: 'store.notifications.removedFromCart.message' }, { productName }),
      autoDismiss: 0
    })
  }

  displayChangeCartStockNotification = (productName, availableStock) => {
    const { intl } = this.props
    this.props.actionsNotification.showNotification({
      title: intl.formatMessage({
        id: 'store.notifications.cartStockChanged.title'
      }),
      type: 'warning',
      message: intl.formatMessage(
        { id: 'store.notifications.cartStockChanged.message' },
        {
          productName,
          availableStock
        }
      ),
      autoDismiss: 0
    })
  }

  updateStoreStock = stock => {
    const store = cloneDeep(this.props.activeStore)
    stock.products.map(item => store.changeProductStock(item._id, item.stock_quantity))
    this.props.actionsActiveStore.setActiveStore(store)
  }

  // obsolete, but will be re introduced
  // passed via props product card
  onProductClick = product => {
    this.props.history.push(`/store/${this.props.activeStore.shortId}/product/${product._id}`)
  }

  showProductModal = product => this.setState({ modalProduct: product })

  // I prefer to leave this here right now, since tile is dumy component, and we will have control of this action in one place
  onAddToCart = product => {
    this.props.actions.addProduct(product)
    if (this.props.isZeroTouch && this.props.activeStore.isSubOptionsEnabled() && product.hasSubOptions()) {
      this.showProductModal(product)
    }
  }

  // I prefer to leave this here right now, since tile is dumy component, and we will have control of this action in one place
  onRemoveFromCart = product => {
    this.props.actions.removeProduct(product)
  }

  toggleCheckoutModal() {
    this.setState({ checkoutModalShow: !this.state.checkoutModalShow })
  }

  onCheckout() {
    this.props.actionsCheckout.clearCheckout()
    this.props.actionsCheckout.setCancelIndicator(false)
    this.props.actionsCheckout.setPaymentStatus('pending', {}, 'checkout', this.props.activeStore.getShortId())
    this.toggleCheckoutModal()
  }

  render() {
    const { cart, history, activeStore, intl, loaded, isPrivate, toggleGeolocationModal, storeTheme } = this.props
    const { shareModalToggled, productDetailsToggled, checkoutModalShow, actionButtonsToggled } = this.state

    const storeThemeFunc = theme => {
      const coverPhoto = storeTheme.cover_photo
      return {
        ...theme,
        ...(coverPhoto && { cover_photo: coverPhoto }),
        ...storeTheme
      }
    }

    const modalOpen = Boolean(shareModalToggled || productDetailsToggled || checkoutModalShow || actionButtonsToggled)

    if (!storeTheme) {
      return null
    }

    return (
      <ThemeProvider theme={storeThemeFunc}>
        <React.Fragment>
          {!activeStore.isInsideGeo() && (
            <TopBarNotificationBox
              toggleGeolocationModal={toggleGeolocationModal}
              title={intl.formatMessage({ id: 'store.outOfGeo.header' })}
              content={intl.formatMessage({ id: 'store.outOfGeo.description' })}
              icon={MdLocationOff}
              fixedBar
              storeSource={activeStore.source}
              fixedBarMessage={intl.formatMessage({
                id: 'topBarNotification.geoLockedStore'
              })}
              fixedBarActionMessage={intl.formatMessage({
                id: 'topBarNotification.readMore'
              })}
            />
          )}
          <BackToThirdPartyBar />

          <StoreViewTopBar
            modalOpen={modalOpen}
            history={history}
            activeStore={activeStore}
            isZeroTouch={this.props.isZeroTouch}
            isMobile={isMobile}
            toggleShareModal={toggled => this.setState({ shareModalToggled: toggled })}
            onToggle={toggled => this.setState({ actionButtonsToggled: toggled })}
          />
          <BlurredWrapper blurred={isPrivate}>
            <StoreViewHeader
              loaded={loaded}
              isMobile={isMobile}
              isZeroTouch={this.props.isZeroTouch}
              actionButtonsToggled={actionButtonsToggled}
              activeStore={activeStore}
              storeTheme={storeTheme}
              toggleShareModal={toggled => this.setState({ actionButtonsToggled: toggled })}
              onToggle={toggled => this.setState({ shareModalToggled: toggled })}
            />

            <Content modalopen={modalOpen ? 1 : 0}>
              <StoreViewProducts
                cart={cart}
                activeStore={activeStore}
                onProductClick={this.onProductClick}
                onRemoveFromCart={this.onRemoveFromCart}
                onAddToCart={this.onAddToCart}
              />
              <Row>
                <Col
                  xs={{ size: '12' }}
                  sm={{ size: 10, offset: 1 }}
                  lg={{ size: 10, offset: 1 }}
                  xl={{ size: 8, offset: 2 }}
                  className="p-1 p-sm-2 p-md-2"
                >
                  <CampaignBanner
                    name={activeStore.getOwnerName()}
                    campaignData={activeStore.getCampaingTag()}
                    instagram={activeStore.getOwnerInstagram()}
                    storeId={activeStore.getShortId()}
                  />
                </Col>
              </Row>
              <Row>
                <Col
                  xs={{ size: '12' }}
                  sm={{ size: 10, offset: 1 }}
                  lg={{ size: 10, offset: 1 }}
                  xl={{ size: 8, offset: 2 }}
                  className="p-1 p-sm-2 p-md-2"
                >
                  {(activeStore.getAboutHTML() || activeStore.getOwnerSocial().length > 0) && (
                    <div>
                      <AboutHausmart
                        name={activeStore.source === 'ZEROTOUCH' ? activeStore.getName() : activeStore.getOwnerName()}
                        description={activeStore.getAboutHTML()}
                        socialMedia={activeStore.getOwnerSocial()}
                      />
                    </div>
                  )}
                </Col>
              </Row>
              {activeStore.isInsideGeo() && (
                <React.Suspense fallback={null}>
                  <CheckoutWidgetButton
                    key="cartWidget"
                    history={history}
                    onCheckout={() => {
                      this.onCheckout()
                    }}
                    shortId={activeStore.getShortId()}
                  />
                </React.Suspense>
              )}
              {/* take a look after review, if still will be a lot of props then consider other solutions */}
              {checkoutModalShow && (
                <CheckoutModal
                  key="checkoutModal"
                  storeId={activeStore.getShortId()}
                  merchantId={activeStore.getMerchantId()}
                  isOpen={checkoutModalShow}
                  ct={this.ct}
                  toggle={() => {
                    this.toggleCheckoutModal()
                  }}
                />
              )}
            </Content>
          </BlurredWrapper>
        </React.Fragment>
        {this.state.modalProduct && (
          <ProductDetailsModal
            isOpen={true}
            toggle={() => this.setState({ modalProduct: null })}
            product={this.state.modalProduct}
            storeId={activeStore.getShortId()}
          />
        )}
      </ThemeProvider>
    )
  }
}

// check that
StoreView.propTypes = {
  onStoreLoaded: PropTypes.func.isRequired,
  cart: PropTypes.object,
  intl: PropTypes.object.isRequired,
  activeStore: PropTypes.object.isRequired,
  actionsCheckout: PropTypes.object.isRequired,
  actionsNotification: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  checkout: PropTypes.object,
  actionsCookies: PropTypes.object.isRequired,
  history: PropTypes.object,
  location: PropTypes.object,
  actionsActiveStore: PropTypes.object.isRequired,
  storeTheme: PropTypes.object,
  loaded: PropTypes.bool,
  isPrivate: PropTypes.bool,
  toggleGeolocationModal: PropTypes.func.isRequired,
  isZeroTouch: PropTypes.bool
}

const mapStateToProps = state => {
  return {
    cart: state.cart,
    cookiesState: state.cookies,
    checkout: state.checkout
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  actionsNotification: bindActionCreators(actionsNotification, dispatch),
  actionsCookies: bindActionCreators(actionsCookies, dispatch),
  actionsActiveStore: bindActionCreators(actionsActiveStore, dispatch),
  actionsCheckout: bindActionCreators(actionsCheckout, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(StoreView))
